"use client";
import Select, { SingleValue, MultiValue, PropsValue } from "react-select";
import { Controller, Control } from "react-hook-form";
import React from "react";
import ErrorMessage from "@/components/shared/Form/ErrorMessage";
import { get } from "lodash";

interface OptionType {
  value: string | number;
  label: string;
}

interface CustomSelectProps {
  options: OptionType[];
  name: string;
  control: Control<any>;
  errors: any;
  isMulti?: boolean;
  optionsComponent?: any;
}

const CustomSelect: React.FC<CustomSelectProps> = ({
  options,
  name,
  control,
  errors,
  optionsComponent,
  isMulti = false,
}) => {
  const hasError = Boolean(get(errors, name));

  return <div
    className="w-full"
    data-field-name={name}
  >
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        // Ensure field.value is properly typed and initialized
        const value = isMulti
          ? (field?.value as string[] | undefined)
              ?.map((val) => options?.find((option) => option?.value === val))
              ?.filter((option): option is OptionType => option !== undefined)
          : options?.find((option) => option?.value === field?.value) || null;

        return (
          <div>
            <Select<OptionType, boolean>
              {...field}
              options={options}
              components={optionsComponent ? { Option: optionsComponent } : {}}
              onChange={(selectedOption: SingleValue<OptionType> | MultiValue<OptionType>) => {
                if (isMulti) {
                  // Handle multi-select
                  field.onChange((selectedOption as MultiValue<OptionType>).map((option) => option.value));
                } else {
                  // Handle single-select
                  field.onChange((selectedOption as SingleValue<OptionType>)?.value || "");
                }
              }}
              value={value as PropsValue<OptionType>}
              isMulti={isMulti}
              isClearable={true}
              placeholder="اختر"
              className={`w-full rounded-lg text-right ${
                hasError ? "ring-2 ring-red-100" : ""
              }`}
              classNamePrefix={hasError ? "select-error" : "select"}
              styles={{
                control: (base, state) => ({
                  ...base,
                  minHeight: "44px",
                  borderRadius: "12px",
                  borderColor: hasError
                    ? "#f87171"
                    : state.isFocused
                    ? "#1F0570"
                    : "#e5e7eb",
                  boxShadow: state.isFocused
                    ? hasError
                      ? "0 0 0 2px #fee2e2"
                      : "0 0 0 2px rgba(31,5,112,.10)"
                    : "none",
                  "&:hover": {
                    borderColor: hasError ? "#ef4444" : "#1F0570",
                  },
                }),
              }}
            />
            <ErrorMessage errors={errors} name={name} />
          </div>
        );
      }}
    />
  </div>
};

export default CustomSelect;
